/**
 * WooCommerce Checkout Blocks JavaScript for Lemon Squeezy
 */
import { decodeEntities } from '@wordpress/html-entities';

const { registerPaymentMethod } = window.wc.wcBlocksRegistry;
const { createElement } = window.wp.element;
const { __ } = window.wp.i18n;
const { getSetting } = window.wc.wcSettings;

const settings = getSetting( 'lemon_squeezy_data', {} );

const Label = () => {
	return decodeEntities( settings.title || __( 'Lemon Squeezy', 'lemon-squeezy-for-woocommerce' ) );
};

const Content = () => {
	return createElement(
		'div',
		{ className: 'wc-block-payment-method-lemon-squeezy' },
		decodeEntities( settings.description || __( 'Pay securely with credit cards, PayPal, and more via Lemon Squeezy.', 'lemon-squeezy-for-woocommerce' ) )
	);
};

const paymentMethodConfig = {
	name: 'lemon_squeezy',
	label: createElement( Label ),
	content: createElement( Content ),
	edit: createElement( Content ),
	canMakePayment: () => true,
	ariaLabel: decodeEntities( settings.title || __( 'Lemon Squeezy', 'lemon-squeezy-for-woocommerce' ) ),
	supports: {
		features: settings.supports || ['products']
	}
};

registerPaymentMethod( paymentMethodConfig );